import { ServiceFetch } from '../service-fetch'

export default class CustomerTierBenefitModel extends ServiceFetch {
    generateCustomerTierBenefitLastCode = (data) => this.authFetch({
        url: 'customer-tier-benefit/generateCustomerTierBenefitLastCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getCustomerTierBenefitBy = (data) => this.authFetch({
        url: 'customer-tier-benefit/getCustomerTierBenefitBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getCustomerTierBenefitByCode = (data) => this.authFetch({
        url: 'customer-tier-benefit/getCustomerTierBenefitByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updateCustomerTierBenefitBy = (data) => this.authFetch({
        url: 'customer-tier-benefit/updateCustomerTierBenefitBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    insertCustomerTierBenefit = (data) => this.authFetch({
        url: 'customer-tier-benefit/insertCustomerTierBenefit',
        method: 'POST',
        body: JSON.stringify(data),
    })

    deleteCustomerTierBenefitByCode = (data) => this.authFetch({
        url: 'customer-tier-benefit/deleteCustomerTierBenefitByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
}